import { render, staticRenderFns } from "./ksOutpatientVisit.vue?vue&type=template&id=fc3f95fc&scoped=true&"
import script from "./ksOutpatientVisit.vue?vue&type=script&lang=js&"
export * from "./ksOutpatientVisit.vue?vue&type=script&lang=js&"
import style0 from "./ksOutpatientVisit.vue?vue&type=style&index=0&id=fc3f95fc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3f95fc",
  null
  
)

export default component.exports